import React from "react";

const Footer = () => {
  return <div className="min-h-5"></div>;
};

export default Footer;
